module.exports = __webpack_public_path__ + "media/npc_dota_hero_bloodseeker.828e4cc2.webm";